import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import AdminLayout from "@/pages/admin/AdminLayout";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);
  useEffect(() => {
    api.get("/admin/audit").then(({ data }) => setLogs(data)).catch((err) => { toast.error(formatApiError(err.response?.data?.detail)); setLogs([]); });
  }, []);

  return (
    <AdminLayout>
      <h1 className="text-2xl font-bold mb-6">Registro de auditoría</h1>
      {logs === null ? <div className="flex justify-center py-16"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div> : (
        <div className="bg-white rounded-2xl border border-border overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary/60 border-b border-border"><tr className="text-left text-xs uppercase text-slate-500">
              <th className="px-4 py-3">Fecha</th><th className="px-4 py-3">Usuario</th><th className="px-4 py-3">Acción</th><th className="px-4 py-3">Objeto</th>
            </tr></thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-border">
                  <td className="px-4 py-3 whitespace-nowrap text-muted-foreground">{new Date(l.created_at).toLocaleString("es-CL")}</td>
                  <td className="px-4 py-3">
                    <div className="font-medium text-primary">{l.actor_name || (l.actor_email && l.actor_email.includes("@") ? l.actor_email.split("@")[0] : "Sistema")}</div>
                    <div className="text-xs text-muted-foreground">{l.actor_email && l.actor_email.includes("@") ? l.actor_email : "—"}</div>
                  </td>
                  <td className="px-4 py-3">{l.action_label || l.action}</td>
                  <td className="px-4 py-3 text-muted-foreground">{l.object_label || l.object_type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}
